import { render, staticRenderFns } from "./ResetedPw.vue?vue&type=template&id=4e98adba&scoped=true&"
import script from "./ResetedPw.vue?vue&type=script&lang=js&"
export * from "./ResetedPw.vue?vue&type=script&lang=js&"
import style0 from "./ResetedPw.vue?vue&type=style&index=0&id=4e98adba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e98adba",
  null
  
)

export default component.exports